import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  container: {
    ...dFlex('initial', 'flex-start'),
    flexDirection: 'column',
    gap: 16,
  },
  wrap: {
    padding: '16px',
    width: '100%',
    ...dFlex('space-between', 'center'),
    flexDirection: 'column',
    height: 'calc(100vh - 92px)',
  },
  logo: {
    width: 200,
    height: 200,
  },
}));

export default useStyles;
